import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authClient } from '../lib/auth-client';
import { Button, Card, CardBody, Input } from '@img/ui';

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 8) { setError('كلمة المرور 8 أحرف على الأقل'); return; }
    if (password !== confirm) { setError('كلمتا المرور غير متطابقتين'); return; }
    if (!token) { setError('الرابط غير صحيح'); return; }
    setBusy(true);
    setError(null);
    try {
      await authClient.resetPassword({ newPassword: password, token });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError((err as Error).message ?? 'فشل تحديث كلمة المرور');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--bg-light)]">
      <Card className="w-full max-w-md">
        <CardBody className="p-8">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-black text-navy-dark">كلمة مرور جديدة</h1>
          </div>

          {success ? (
            <div className="text-center py-8">
              <div className="text-5xl mb-3">✅</div>
              <h2 className="font-black text-navy-dark mb-2">تم تحديث كلمة المرور</h2>
              <p className="text-sm text-gray-600">جاري تحويلك لتسجيل الدخول…</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input label="كلمة المرور الجديدة"  type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
              <Input label="تأكيد كلمة المرور"     type="password" value={confirm}  onChange={(e) => setConfirm(e.target.value)} required />
              {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg p-3">
                  {error}
                </div>
              )}
              <Button type="submit" variant="gold" size="lg" loading={busy} className="w-full">
                تحديث كلمة المرور
              </Button>
              <div className="text-center text-sm text-gray-600">
                <Link to="/login" className="text-navy-dark font-bold hover:text-gold">
                  ← العودة لتسجيل الدخول
                </Link>
              </div>
            </form>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
